import * as React from 'react';

import { useHistory } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
// import Cookies from 'universal-cookie';
import Config from '../../../config';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { COMMON_PROPERTY } from '../../../store/property/common/commonProperty.reducer';
import { useDispatch } from 'react-redux';
import { SET_FORCE_LOGOUT_VAR } from '../../../store/property/common/commonProperty.actionsType';
import { useSelector } from '../../../store/reducer';
import { appForceLogout, fetchCommonPropertyById } from '../../../store/property/common/commonProperty.actions';

import superAdmin from '../../../menu-items-admin';
import { fetchUnitMaster } from '../../../store/unitMaster/unitMaster.actions';
import { fetchSeasonMaster } from '../../../store/seasonMaster/seasonMaster.actions';
import { fetchPartyDetailsData } from '../../../store/partyDetails/partyDetails.action';
import { initialLoadCommon } from '../../../App/components/Common/Util';
import LoginForm from './LoginForm';
import ForgotPassword from './ForgotPassword';
import { LOADING_MODAL_CLOSE } from '../../../store/actions';
import { PROPERTY_MASTER } from '../../../store/propertyMaster/propertyMaster.reducer';
import { getIpAddress } from '../../../store/propertyMaster/propertyMaster.actions';

const theme = createTheme();


export default function LoginV2() {
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const [showForgotPassword, setShowForgotPassword] = React.useState(false);
    const usernameRef = React.useRef(null);
    const passwordRef = React.useRef(null);
    const [loading, setLoading] = React.useState(false)
    let history = useHistory();
    let dispatch = useDispatch();

    let { isForceLogout } = useSelector((state) => {
        return state[COMMON_PROPERTY];
    });

    let { ipAddressInfo } = useSelector((state) => {
        return state[PROPERTY_MASTER];
    });


    const isFromApp = navigator.userAgent.includes('eprotex-app')
    // const isFromApp = true

    let cpheaders = {
        'Access-Control-Allow-Origin': true,
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Content-Type': 'application/json'
    };




    React.useEffect(() => {
        const payload = JSON.parse(localStorage.getItem('Login'));
        if (payload) {
            let data = {
                username: payload.username,
                password: payload.password
            };
            let cpData = {
                Username: payload.username,
                Password: payload.password
            };
            // checkInitiallyLogin(cpData, data);
        }
        dispatch(getIpAddress());
    }, [])


    const checkInitiallyLogin = (cpData, data) => {
        axios
            .post(`${Config.baseUrl}/api/CPAuthenticate/login`, cpData, { cpheaders })
            .then((res) => {
                Cookies.set('DATABASE', `${res.data.fldDatabase}`);
                Cookies.set('USERID', `${res?.data?.fldUserName}`);
                Cookies.set('PASSWORD', `${res?.data?.fldPassword}`);
                Cookies.set('URL', Config.baseUrl);
                let headers = {
                    'Access-Control-Allow-Origin': true,
                    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json',
                    dbname: Cookies.get('DATABASE')
                };
                axios
                    .post(`${Config.baseUrl}/api/Authenticate/Login/login?FldIPAddress=${ipAddressInfo?.IPv4}`, data, { headers })
                    .then((res) => {
                        // Cookies.set('JWT_TOKEN', res.data);
                        Cookies.set('JWT_TOKEN', res.data[0].fldToken);



                        dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: false });


                        localStorage.setItem('Login', JSON.stringify(data));

                        const config = {
                            headers: {
                                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                                'Access-Control-Allow-Origin': true,
                                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                                'Content-Type': 'application/json',
                                dbname: Cookies.get('DATABASE')
                            }
                        };

                        axios.post(
                            `${Config.baseUrl}/api/TblMail/CheckAllowedByIP?FldIpAddress=${ipAddressInfo?.IPv4}`,
                            {},
                            config
                        ).then((res) => {
                            // console.log(res.data);
                        }).catch((error) => {
                            dispatch({ type: LOADING_MODAL_CLOSE });
                            console.error(error);
                        });

                        if (res?.data?.length === 1) {

                            axios
                                .get(`${Config.baseUrl}/api/TblDashboard/GetUserProfile`, config)
                                .then((res) => {
                                    Cookies.set('USER', JSON.stringify(res.data));
                                    Cookies.set('FKUser', JSON.stringify(res.data.fldFKUser));
                                    Cookies.set('FKCompany', JSON.stringify(res.data.fldFKCompany));
                                    let payload = JSON.parse(localStorage.getItem('Login'));

                                    if (payload.username !== 'cb@eprotex.software') {
                                        history.push('/bulk/dashboard');
                                    }


                                    initialLoadCommon(dispatch)
                                    setLoading(false)
                                    if (res.data.fldRole === 'Super Admin') {
                                        localStorage.setItem('MENUS', JSON.stringify(superAdmin));
                                    } else {
                                        getUsersMenu()


                                    }

                                })
                                .catch((err) => {
                                    toast.error(err?.response?.data);
                                });
                        }
                        else {
                            history.push({
                                pathname: '/company',
                                state: { companies: res.data } // Pass the entire array of companies
                            });
                        }
                    })
                    .catch((err) => {
                        toast.error(err?.response?.data);
                        setLoading(false)
                        if (err?.response?.data?.status == 401) {
                            toast.error('Invalid Credentials');
                        }
                        if (err?.response?.data == 'User already logged in') {
                            dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: true });
                        } else {
                            dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: false });
                        }
                    });
            })
            .catch((err) => {
                toast.error('Invalid Credentials');
                setLoading(false)
            });
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true)
        const formData = new FormData(event.currentTarget);

        let data = {
            username: formData.get('username'),
            password: formData.get('password')
        };
        let cpData = {
            Username: formData.get('username'),
            Password: formData.get('password')
        };
        checkInitiallyLogin(cpData, data);
    };

    const getUsersMenu = () => {
        const config = {
            headers: {
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                'Access-Control-Allow-Origin': true,
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Content-Type': 'application/json',
                dbname: Cookies.get('DATABASE')
            }
        };
        axios
            .get(`${Config.baseUrl}/api/TblDashboard/GetUsersMenu`, config).then((res) => {
                localStorage.setItem('MENUS', JSON.stringify(res.data));

                let payload = JSON.parse(localStorage.getItem('Login'));


                setTimeout(() => {
                    window.location.reload(true);

                }, 100)

                let UserMenu = JSON.parse(localStorage.getItem('MENUS'));

                const hasRegisteredVendor = UserMenu?.some(item =>
                    item.children?.some(child => child.title === 'Registered Vendor')
                )

                if (hasRegisteredVendor && isFromApp) {
                    history.push('/registered-vendor');
                    dispatch({ type: LOADING_MODAL_CLOSE });

                } else if (isFromApp == true) {
                    history.push('/');
                    toast.error('No Menu Found')
                    dispatch({ type: LOADING_MODAL_CLOSE });

                }

                if (payload.username == 'cb@eprotex.software') {
                    history.push('/contractor-bill');
                }

                dispatch({ type: LOADING_MODAL_CLOSE });


            }).catch((err) => {
                toast.error(err?.response?.data);
                dispatch({ type: LOADING_MODAL_CLOSE });

            });
    }

    const callForceLogout = () => {
        dispatch(appForceLogout());
    };

    return (
        <div>

            {isFromApp == false ?
                <ThemeProvider theme={theme}>
                    <Container
                        component="main"
                        // @ts-ignore
                        maxWidth="vw"
                        sx={{
                            background: 'linear-gradient(130deg, #feedd3, #9dc9f6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <CssBaseline />
                        <Box
                            autoComplete="off" // Disable autofill globally for the form

                            sx={{
                                flexDirection: 'column',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100vh',
                                width: '100%'
                                // backgroundColor: 'blue'
                            }}
                        >
                            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                <LockOutlinedIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Sign in
                            </Typography>


                            <Box
                                autoComplete="off" // Disable autofill globally for the form
                                id='loginForm'
                                component="form"
                                onSubmit={handleSubmit}
                                sx={{
                                    mt: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',

                                    minWidth: '30%',
                                    maxWidth: '60%'
                                }}
                            >

                                <TextField
                                    inputProps={{
                                        autoComplete: 'none'
                                    }}
                                    ref={usernameRef}
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="username"
                                    label="User Name"
                                    name="username"
                                    autoComplete="off"
                                    // onFocus={() => handleFocus("username")}

                                    autoFocus
                                    sx={{
                                        backgroundColor: '#fff',
                                        borderRadius: 10,
                                        '& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root': {
                                            borderRadius: 10
                                        },
                                        minWidth: '40%'
                                    }}
                                />
                                {/* <TextField
        margin="normal"
        // required
        fullWidth
        id="email"
        label="Email Address"
        name="email"
        disabled
        autoComplete="off"
        autoFocus
        sx={{
            backgroundColor: '#fff',
            borderRadius: 10,
            '& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root': {
                borderRadius: 10
            }
        }}
    /> */}

                                {/* <p>Password: <input class="key" type="text" autocomplete="off" /></p> */}


                                <TextField
                                    autoComplete="new-password" // Trick Chrome into not autofilling
                                    variant="outlined"
                                    type={showPassword ? 'text' : 'password'}
                                    ref={passwordRef}

                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    id="password"
                                    sx={{
                                        backgroundColor: '#fff',
                                        borderRadius: 10,
                                        '& .MuiOutlinedInput-root': { borderRadius: 10 }
                                    }}
                                    InputProps={{
                                        // form: { autoComplete: 'off' },
                                        autoComplete: 'new-password',
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                // disabled={autoFilledEntry === true}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />



                                {!isForceLogout ? (
                                    <Grid container alignItems="center" justifyContent="space-around">
                                        <Grid item>
                                            <FormControlLabel
                                                sx={{
                                                    color: '#1491dc'
                                                }}
                                                control={<Checkbox value="remember" color="primary" />}
                                                label="Remember me"
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Link align="center" href="#" variant="body2" sx={{ textDecoration: 'none' }}>
                                                Forgot password?
                                            </Link>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid container alignItems="center" justifyContent="space-around">
                                        <Grid item>
                                            <div
                                                style={{ color: '#1976d2', fontSize: '1rem', cursor: 'pointer' }}
                                                onClick={() => callForceLogout()}
                                            >
                                                ForceLogout
                                            </div>
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                                    <Button
                                        disabled={loading}
                                        type="submit"
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2, borderRadius: 10, paddingY: 1.2, paddingX: 7, fontSize: 20 }}
                                    >
                                        {loading ? <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div> : 'Login'}

                                    </Button>

                                </Grid>
                            </Box>
                        </Box>
                    </Container>
                </ThemeProvider> : !showForgotPassword ? (
                    <LoginForm onForgot={() => setShowForgotPassword(true)} getUsersMenu={getUsersMenu} setLoading={setLoading} loading={loading} />
                ) : (
                    <ForgotPassword onBack={() => setShowForgotPassword(false)} />
                )}
        </div>
    );
}
